import { render, staticRenderFns } from "./BoardAteReport.vue?vue&type=template&id=a74ed63c&scoped=true&"
import script from "./BoardAteReport.vue?vue&type=script&lang=js&"
export * from "./BoardAteReport.vue?vue&type=script&lang=js&"
import style0 from "./BoardAteReport.vue?vue&type=style&index=0&id=a74ed63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ed63c",
  null
  
)

export default component.exports